import { imageDB } from "../../utils/imageDB";

export default {
    brand: {
        appName: "DH Mobility Store",
        slogan: "택시 기사님 전용 액세서리몰",
        description: "운행에 필요한 장비와 소모품, 믿을 수 있는 품질로 빠르게 만나보세요.",
    },

    landing: {
        sliderItems: [
            {
                title: "기사님 필수템 총집합",
                lines: ["충전기, 거치대, 블랙박스까지", "지금 바로 필요한 제품을 만나보세요."],
                image: imageDB.scene1, // 기존 이미지 그대로 사용
                bg: "#F4F8FF",
            },
            {
                title: "운행 편의성을 높이는 아이템",
                lines: ["운행 시간, 차량 환경, 스타일에 맞춰", "딱 맞는 액세서리를 추천해드립니다."],
                image: imageDB.scene2,
                bg: "#F8FFF4",
            },
            {
                title: "정품 보장 · 빠른 배송",
                lines: ["믿을 수 있는 정품만 취급하며", "전국 어디든 빠르게 배송됩니다."],
                image: imageDB.scene3,
                bg: "#FFF8F2",
            },
        ],
    },

    providers: ["google", "naver", "kakao"],

    texts: {
        signinTitle: "로그인",
        signupTitle: "회원가입",
        emailLabel: "아이디 또는 이메일",
        idLabel: "아이디",
        pwLabel: "비밀번호",
        signinBtn: "로그인",
        passStartBtn: "PASS로 본인확인",
        alimtalkStartBtn: "카카오 알림톡으로 인증코드 받기",
        otpPlaceholder: "6자리 인증코드",
    },

    phoneAuth: {
        method: "pass",     // "pass" | "alimtalk"
        otpTtlSec: 180,
        resendWaitSec: 60,
    },

    postSignInRoute: "/home",
    postSignOutRoute: "/loginlanding",
};
